export default async function clearForm(formElement) {
    formElement.reset();
    
    formElement.querySelectorAll('input, textarea, select').forEach(function (element) {
        element.dispatchEvent(new CustomEvent("input"));
        element.dispatchEvent(new CustomEvent("change"));
    });

    formElement.dispatchEvent(new CustomEvent("clear"));
}
